// 수원대학교 교시 기준
export const PERIOD_TIMES = {
  1:  { start: "09:30", end: "10:20" },
  2:  { start: "10:30", end: "11:20" },
  3:  { start: "11:30", end: "12:20" },
  4:  { start: "12:30", end: "13:20" },
  5:  { start: "13:30", end: "14:20" },
  6:  { start: "14:30", end: "15:20" },
  7:  { start: "15:30", end: "16:20" },
  8:  { start: "16:30", end: "17:20" },
  9:  { start: "17:25", end: "18:10" },
  10: { start: "18:15", end: "19:00" },
  11: { start: "19:05", end: "19:50" },
  12: { start: "19:55", end: "20:40" },
  13: { start: "20:45", end: "21:30" },
}

export const MAX_PERIOD   = 13
export const NIGHT_START  = 9  // 9교시부터 야간
export const MAX_CREDITS  = 21 // 한 학기 최대 신청 학점
